import { Helmet } from 'react-helmet-async';

const SITE_URL  = process.env.REACT_APP_SITE_URL || 'https://vietnamyosakoi.com';
const SITE_NAME = 'Vietnam Yosakoi Festival';
const DEFAULT_IMG = `${SITE_URL}/images/cover.jpg`;

function PageMeta({ title, description, image, url, type = 'website' }) {
    const fullTitle   = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const fullDesc    = description || 'Vietnam Yosakoi Festival – Lễ hội nhảy Yosakoi tại Việt Nam.';
    const fullImage   = image || DEFAULT_IMG;
    const fullUrl     = url ? `${SITE_URL}${url}` : SITE_URL;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={fullDesc} />

            <meta property="og:type"        content={type} />
            <meta property="og:site_name"   content={SITE_NAME} />
            <meta property="og:title"       content={fullTitle} />
            <meta property="og:description" content={fullDesc} />
            <meta property="og:image"       content={fullImage} />
            <meta property="og:url"         content={fullUrl} />

            <meta name="twitter:card"        content="summary_large_image" />
            <meta name="twitter:title"       content={fullTitle} />
            <meta name="twitter:description" content={fullDesc} />
            <meta name="twitter:image"       content={fullImage} />
        </Helmet>
    );
}

export default PageMeta;
